const { createRecipeTiles } = require('../../shop/tiles/recipe-tile-factory');

class RecipeListTileListController {
    constructor(settings, recipeListsService, sortByKeys) {
        this.settings = settings;
        this.recipeListsService = recipeListsService;
        this.sortByKeys = sortByKeys;
    }

    $onInit() {
        this.sortOptions = { sortTypes: this.settings.recipe.sortOptions, sortContext: this.sortByKeys.RECIPE_KEY };
    }

    createTiles(tiles) {
        return {
            items: createRecipeTiles(tiles.items),
            totalRecordCount: tiles.totalRecordCount,
        };
    }

    getTiles(pageSize, pageNumber, sortType) {
        return this.recipeListsService.getSavedRecipes(pageSize, pageNumber, sortType)
            .then(tiles => this.createTiles(tiles));
    }
}

RecipeListTileListController.$inject = ['Settings', 'RecipeListsService', 'SortByKeys'];

const recipeListTileListComponentDefinition = {
    bindings: {
        currentCategory: '<',
        pageNumber: '<',
        sortBy: '<',
    },
    controller: RecipeListTileListController,
    template: `
        <wow-tile-list
            list-title="::'My Favourite Recipes'"
            page-number="$ctrl.pageNumber"
            sort-by="$ctrl.sortBy"
            sort-options="::$ctrl.sortOptions"
            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)">
        </wow-tile-list>
    `,
};

module.exports = {
    RecipeListTileListController,
    recipeListTileListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/recipe/recipe-savedList/recipe-savedList-tile-list.component.js